import MainLayout from 'components/templates/MainLayout';

const Links = () => {
	return <MainLayout url="links"></MainLayout>;
};

export default Links;
